import { useEffect, useState } from 'react'
import { Button, Card, CardBody, Collapse, Modal } from 'reactstrap';
import { IUserDetail } from 'src/services/types';
import { toast } from 'react-toastify';
import "react-image-lightbox/style.css";
import { getUserDetails, updateUserVerifiedByAdmin } from 'src/services/users-service';
import { Spinner } from 'src/components/Common/Spinner';
import { PlaidInformation } from '../UsersToValidate/PlaidInformation';
import { ChevronDown, ChevronUp, ChevronLeft, ChevronRight, X, Check } from 'feather-icons-react';
import { DetailsUserInformation } from './DetailsUserInformation';

interface IProps {
    show: boolean;
    onClose: () => void;
    userId: string;
    onNext?: (userId: string, isBeforeAction?: boolean) => void;
    onPrev?: (userId: string) => void;
    buttonNextDisabled?: boolean;
    buttonPrevDisabled?: boolean;
    isViewUser?: boolean;
    activeButtonsNextPrev?: boolean;
    activeValidateRejectButtons?: boolean;
} 

export const DetailsUserModal = ({ 
    show, 
    onClose, 
    userId, 
    onNext, 
    onPrev, 
    buttonNextDisabled,
    buttonPrevDisabled,
    isViewUser = false,
    activeButtonsNextPrev = false,
    activeValidateRejectButtons = false
}: IProps) => {
    
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState<IUserDetail | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenPlaid, setIsOpenPlaid] = useState(false);

    const toggle = () => setIsOpen(!isOpen);
    const togglePlaid = () => setIsOpenPlaid(!isOpenPlaid);

    const getUserDetail = async () => {
        setLoading(true);
        const res = await getUserDetails(userId)
        setLoading(false);
        if (res.result === 'ok') {
            setUser(res.data);
        } else {
            console.log('error:', res.message);
            toast(res.message, { type: 'error'});
        }
    }

    const [loadingValidate, setLoadingValidate] = useState(false);
    const [loadingReject, setLoadingReject] = useState(false);

    const onValidate = async () => {
        // setError('');
        setLoadingValidate(true);
        try {
            const res = await updateUserVerifiedByAdmin(userId, true);
            if (res.result === 'ok') {
                toast('User validated successfully', { type: 'success'});
                // onRefresh();
                onNext ? onNext(userId, true) : null;
                // onRefresh ? onRefresh() : null;
                // onClose();
            } else {
                toast(res.message || 'An error has occurred, please try again later');
            }
            setLoadingValidate(false);
        } catch (error) {
            setLoadingValidate(false);
            toast('An error has occurred, please try again later');
        }
    }

    const onReject = async () => {
        // setError('');
        setLoadingReject(true);
        try {
            const res = await updateUserVerifiedByAdmin(userId, false);
            if (res.result === 'ok') {
                toast('User rejected successfully', { type: 'success'});
                // onRefresh();
                onNext ? onNext(userId, true) : null;
                // onRefresh ? onRefresh() : null;
                // onClose();
            } else {
                toast(res.message || 'An error has occurred, please try again later');
            }
            setLoadingReject(false);
        } catch (error) {
            setLoadingReject(false);
            toast('An error has occurred, please try again later');
        }
    }

    useEffect(() => {
        if(userId)
        getUserDetail();
    }, [userId]);

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
        size='xl'   
    >
        {
         loading ? 
                <div className='d-flex justify-content-center align-items-center' style={{height: '200px'}}>
                    <Spinner text='Loading user...'/>
                </div>
            : (
                <>
                    <div className="modal-header">
                        <div className='d-flex justify-content-between align-items-center w-100'>
                            {
                                activeButtonsNextPrev &&
                                <div className='d-flex align-items-center gap-2'>
                                    <Button
                                        color="primary"
                                        onClick={() => onPrev ? onPrev(userId) : null}
                                        disabled={buttonPrevDisabled}
                                    >
                                        <span className='d-flex align-items-center'>
                                            <ChevronLeft size={22} />
                                            <span className='ms-2'>Previous User</span>
                                        </span>
                                    </Button>
                                    <Button
                                        color="primary"
                                        onClick={() => onNext ? onNext(userId) : null}
                                        disabled={buttonNextDisabled}
                                    >
                                        <span className='d-flex align-items-center'>
                                            <span className='ms-2'>Next User</span>
                                            <ChevronRight size={22} />
                                        </span>
                                    </Button>
                                </div>
                            }
                            <div style={{width: '50px'}}></div>
                            {
                                activeValidateRejectButtons &&
                                <div className='d-flex align-items-center gap-2'>
                                    <Button
                                        color="soft-success"
                                        onClick={(e) => (onValidate(), e.currentTarget.blur())}
                                        disabled={loadingValidate}
                                    >
                                        <span className='d-flex align-items-center'>
                                            {   loadingValidate ? <div><i className="fas fa-spinner fa-spin"></i> <span>Validating...</span></div> :
                                                <>
                                                    <span className='ms-2'>Validate</span>
                                                    <Check size={22} />
                                                </>
                                            }
                                        </span>
                                    </Button>
                                    <Button
                                        color="soft-danger"
                                        onClick={(e) => (onReject(), e.currentTarget.blur())}
                                        disabled={loadingReject}
                                    >
                                        <span className='d-flex align-items-center'>
                                            {   loadingReject ? <div className='mr-2'><i className="fas fa-spinner fa-spin"></i> <span> Rejecting...</span></div> : 
                                                <>
                                                    <span className='ms-2'>Reject</span>
                                                    <X size={22} />
                                                </>
                                            }
                                        </span>
                                    </Button>
                                </div>
                            }
                            <button
                                type="button"
                                className="btn-close pr-5"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                    <div className="modal-body">
                        {
                            !isViewUser ?
                            <>
                                <Button color="ligth" onClick={() => user?.deletedSensitiveDataAt ? null : togglePlaid()} style={{ marginBottom: '1rem', width: '100%', backgroundColor: '#f5efe8' }}>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <h4 style={{color: '#000', textAlign: 'left'}}>
                                            PLAID INFORMATION
                                        </h4>
                                        {
                                            user?.deletedSensitiveDataAt ?
                                                <div>
                                                    <small style={{ color: '#b4926f' }}>Deleted Sensitive Data At:</small>
                                                    <p>{user?.deletedSensitiveDataAt}</p>
                                                </div>
                                            :
                                            <div>
                                                {isOpenPlaid ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
                                            </div>
                                        }
                                    </div>
                                </Button>
                                <Collapse isOpen={isOpenPlaid}>
                                    <Card>
                                        <CardBody>
                                            {
                                                user ? 
                                                <PlaidInformation
                                                    validatedInformation={user?.validatedInformation || null}
                                                    workIdImageBackPath={user?.profile?.workIdImageBackPath || ''}
                                                    workIdImageFrontPath={user?.profile?.workIdImageFrontPath || ''}
                                                    firstName={user?.firstName || ''}
                                                    lastName={user?.lastName || ''}
                                                    isVerified={user?.isVerified}
                                                />
                                                : null
                                            }
                                        </CardBody>
                                    </Card>
                                </Collapse>
                            </>
                            : null
                        }
                        <Button color="ligth" onClick={toggle} style={{ marginBottom: '1rem', width: '100%', backgroundColor: '#f5efe8' }}>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h4 style={{color: '#000', textAlign: 'left'}}>
                                    USER INFORMATION
                                </h4>
                                <div>
                                    {isOpen ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
                                </div>
                            </div>
                        </Button>
                        <Collapse isOpen={isOpen}>
                            <Card>
                                <CardBody>
                                    {
                                        user ? 
                                            <DetailsUserInformation user={user} />
                                        : null
                                    }
                                </CardBody>
                            </Card>
                        </Collapse>
                        {
                            isViewUser ?
                            <>
                                <Button color="ligth" onClick={() => user?.deletedSensitiveDataAt ? null : togglePlaid()} style={{ marginBottom: '1rem', width: '100%', backgroundColor: '#f5efe8' }}>
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <h4 style={{color: '#000', textAlign: 'left'}}>
                                            PLAID INFORMATION
                                        </h4>
                                        {
                                            user?.deletedSensitiveDataAt ?
                                                <div>
                                                    <small style={{ color: '#b4926f' }}>Deleted Sensitive Data At:</small>
                                                    <p>{user?.deletedSensitiveDataAt}</p>
                                                </div>
                                            :
                                            <div>
                                                {isOpenPlaid ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
                                            </div>
                                        }
                                    </div>
                                </Button>
                                <Collapse isOpen={isOpenPlaid}>
                                    <Card>
                                        <CardBody>
                                            {
                                                user ? 
                                                <PlaidInformation
                                                    validatedInformation={user?.validatedInformation || null}
                                                    workIdImageBackPath={user?.profile?.workIdImageBackPath || ''}
                                                    workIdImageFrontPath={user?.profile?.workIdImageFrontPath || ''}
                                                    firstName={user?.firstName || ''}
                                                    lastName={user?.lastName || ''}
                                                    isVerified={user?.isVerified}
                                                />
                                                : null
                                            }
                                        </CardBody>
                                    </Card>
                                </Collapse>
                            </>
                            : null
                        }

                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={onClose}>
                            Ok
                        </button>
                    </div>
                </>
            )
        }
    </Modal>
  )
}
